import { createContext, useContext, useState } from "react";

const KEY = "crm-filters";
export const EMPTY = { stores: [], days: [], hours: [0, 23], period: "30", from: "", to: "", cities: [], provs: [], segment: "", segmentLabel: "" };
const arr = (v) => (Array.isArray(v) ? v : []);
let current = (() => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "{}");
    return { ...EMPTY, ...v, stores: arr(v.stores), days: arr(v.days), cities: arr(v.cities), provs: arr(v.provs),
      hours: Array.isArray(v.hours) && v.hours.length === 2 ? v.hours : [0, 23], period: ["7", "15", "30", "all", "custom"].includes(v.period) ? v.period : "30" };
  } catch (e) { return EMPTY; }
})();

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const PERIODS = [["7", "Settimana"], ["15", "15 giorni"], ["30", "Mese"], ["all", "Tutto"], ["custom", "Da - a"]];

export const periodRange = (f) => {
  if (f.period === "custom") return [f.from || "", f.to || ""];
  if (f.period === "all") return ["", ""];
  const d = new Date();
  d.setDate(d.getDate() - Number(f.period) + 1);
  return [ymd(d), ymd(new Date())];
};

const itDate = (s) => (s ? s.split("-").reverse().join("/") : "");

export const periodLabel = (f) => {
  if (f.period === "custom") return f.from || f.to ? `${itDate(f.from) || "…"} → ${itDate(f.to) || "oggi"}` : "Tutto";
  return { 7: "Ultimi 7 gg", 15: "Ultimi 15 gg", 30: "Ultimi 30 gg", all: "Tutto lo storico" }[f.period];
};

export const globalMonths = (f, allowed) => {
  const [from, to] = periodRange(f);
  if (!from) return { months: "12", rate: 12, label: "Ultimi 12 mesi (filtro: tutto lo storico)" };
  const end = to ? new Date(to) : new Date();
  const days = Math.max(1, Math.round((end - new Date(from)) / 86400000) + 1);
  const m = allowed.find((x) => x * 30 >= days + 31) || allowed[allowed.length - 1];
  return { months: String(m), rate: Math.max(days / 30.4, 0.1), label: periodLabel(f) };
};

export const filterParams = () => {
  const p = {};
  if (current.stores.length) p.f_stores = current.stores.join(",");
  if (current.days.length) p.f_days = current.days.join(",");
  if (current.hours[0] !== 0 || current.hours[1] !== 23) p.f_hours = `${current.hours[0]}-${current.hours[1]}`;
  const [from, to] = periodRange(current);
  if (from) p.f_from = from;
  if (to) p.f_to = to;
  if (current.cities.length) p.f_cities = current.cities.join("|");
  if (current.provs.length) p.f_provs = current.provs.join(",");
  if (current.segment) p.f_segment = current.segment;
  return p;
};

const Ctx = createContext(null);

export function FilterProvider({ children }) {
  const [filters, setState] = useState(current);
  const setFilters = (f) => { current = f; localStorage.setItem(KEY, JSON.stringify(f)); setState(f); };
  const count = filters.stores.length + filters.days.length + (filters.hours[0] !== 0 || filters.hours[1] !== 23 ? 1 : 0)
    + filters.cities.length + filters.provs.length + (filters.segment ? 1 : 0);
  return <Ctx.Provider value={{ filters, setFilters, reset: () => setFilters(EMPTY), count, key: JSON.stringify(filterParams()) }}>{children}</Ctx.Provider>;
}

export const useFilters = () => useContext(Ctx);
